import React, { useMemo } from "react";
import Card from "components/card";
import { MdDelete, MdEdit } from "react-icons/md";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import { FRENCH_DATE_TIME_FORMAT } from "variables/constants";
import moment from "moment";
import SwitchField from "components/fields/SwitchField";

const CheckTable = (props) => {
  const { columnsData, tableData, setGiftRequest, handleRemove, handleStatus } =
    props;

  const columns = useMemo(() => columnsData, [columnsData]);
  const data = useMemo(() => tableData, [tableData]);

  const tableInstance = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    initialState,
  } = tableInstance;
  initialState.pageSize = 10;

  const onChange = ({ target: { checked } }, row) => {
    handleStatus(row?.original, checked);
  };

  return (
    <Card extra={"w-full sm:overflow-auto p-4"}>
      <div className="mt-8 overflow-x-scroll xl:overflow-x-hidden">
        <table
          {...getTableProps()}
          className="w-full"
          variant="simple"
          color="gray-500"
          mb="24px"
        >
          <thead>
            {headerGroups.map((headerGroup, index) => (
              <tr {...headerGroup.getHeaderGroupProps()} key={index}>
                {headerGroup.headers.map((column, index) => (
                  <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    className="border-b border-gray-200 pr-16 pb-[10px] text-start dark:!border-primary-800"
                    key={index}
                  >
                    <div className="text-xs font-bold tracking-wide text-gray-600 lg:text-xs">
                      {column.render("Header")}
                    </div>
                  </th>
                ))}
                <th className="border-b border-gray-200 pr-16 pb-[10px] text-start dark:!border-primary-800">
                  <div className="text-xs font-bold tracking-wide text-gray-600 lg:text-xs">
                    ACTION
                  </div>
                </th>
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row, index) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()} key={index}>
                  {row.cells.map((cell, index) => {
                    let data = "";
                    if (cell.column.Header === "NOM") {
                      data = (
                        <div className="flex items-center gap-2">
                          {/*  <Checkbox /> */}
                          <p className="text-black-800 text-sm font-medium dark:text-white">
                            {cell.value}
                          </p>
                        </div>
                      );
                    } else if (cell.column.Header === "POINTS") {
                      data = (
                        <div className="flex items-center gap-2">
                          {/*  <Checkbox /> */}
                          <p className="text-black-800 text-sm font-medium dark:text-white">
                            {cell.value}
                          </p>
                        </div>
                      );
                    } else if (cell.column.Header === "DATE DE CRÉATION") {
                      data = (
                        <p className="text-black-800 text-sm font-medium dark:text-white">
                          {moment(cell.value).format(FRENCH_DATE_TIME_FORMAT)}
                        </p>
                      );
                    } else if (cell.column.Header === "STATUT") {
                      data = (
                        <div className="flex items-center gap-2">
                          <SwitchField
                            id={"status"}
                            label={
                              cell.value === "ACTIVE" ? "Actif" : "Inactif"
                            }
                            onChange={(e) => onChange(e, row)}
                            checked={cell.value === "ACTIVE" ? true : false}
                          />
                        </div>
                      );
                    }
                    return (
                      <td
                        {...cell.getCellProps()}
                        key={index}
                        className="pt-[14px] pb-[16px] sm:text-[14px]"
                      >
                        {data}
                      </td>
                    );
                  })}
                  <td>
                    <p className="flex">
                      <MdEdit
                        onClick={() => setGiftRequest(row)}
                        className="h-6 w-6 cursor-pointer"
                      />
                      <div className="w-[20px]" />
                      <MdDelete
                        onClick={() => handleRemove(row)}
                        className="h-6 w-6 cursor-pointer"
                      />
                    </p>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </Card>
  );
};

export default CheckTable;
